export const SLIDER_BEFORE_CHANGE = "SLIDER:BEFORE_CHANGE";
export const SLIDER_AFTER_CHANGE = "SLIDER:AFTER_CHANGE";
export const CLICK_EPISODE = 'SLIDER:ITEM:CLICK:EPISODE';
export const CLICK_IFI = 'SLIDER:ITEM:CLICK:IFI'